import { WithStyles } from '@material-ui/core'
import {
  AddApartmentMedia,
  Navigate,
  UpdateApartmentClientInformation,
  UpdateApartmentClientInformationToOverview,
  UpdateApartmentConfirmation,
  UpdateApartmentInformation
} from '../actions/types'
import { BucketObject } from '../services/storage/types'
import { Apartment, ClientContactInfo } from './apartments'
import { PathValue } from './returnTypes'

export interface BaseStepProps {
  currentStep: number
  doStepBack?: any
  apartment?: Apartment
  isMobile?: any
  doStepForward?: any
}

export interface BaseFormStepProps extends BaseStepProps {
  isAdmin: boolean
  isConfirmed: PathValue<boolean>
}

export interface Step1Props extends WithStyles {
  updateApartmentClientInfo: UpdateApartmentClientInformation
  updateApartmentClientInfoToOverview: UpdateApartmentClientInformationToOverview
  clientContactInfo: ClientContactInfo | undefined
  areUsersLoading: boolean
  baseFormStepProps: BaseFormStepProps
}

export interface Step2Props extends WithStyles {
  updateApartmentInfo: UpdateApartmentInformation
  baseFormStepProps: BaseFormStepProps
}

export interface Step3Props extends WithStyles, BaseStepProps {
  addApartmentMediaFiles: AddApartmentMedia
  deleteMedia: (arg: any) => any
  reorderMedia: (arg: any) => any
  doConfirmMedia: () => void
  files: BucketObject[]
  baseFormStepProps: BaseFormStepProps
}

export interface Step4Props extends WithStyles {
  apartmentConfirmation: UpdateApartmentConfirmation
  baseFormStepProps: BaseFormStepProps
}

export interface Step5Props extends WithStyles, BaseStepProps {
  doNavigate: Navigate
}

interface StepsProps
  extends Step1Props,
    Step2Props,
    Step3Props,
    Step4Props,
    Step5Props {}

export const ApartmentStepPageNames = {
  0: 'Apartment Creation - step/0' as const,
  1: 'Apartment Creation - step/1' as const,
  2: 'Apartment Creation - step/2' as const,
  3: 'Apartment Creation - step/3' as const,
  4: 'Apartment Creation - step/4' as const,
  5: 'Apartment Creation - step/5' as const,
  6: 'Apartment Creation - step/6' as const,
  7: 'Apartment Creation - step/7' as const,
  8: 'Apartment Creation - step/8' as const,
  9: 'Apartment Creation - step/9' as const,
  10: 'Apartment Creation - step/10' as const
}

export const NewApplicationStepPageNames = {
  0: 'New Application - Choose Language' as const,
  1: 'New Application Form - Step 1' as const,
  2: 'New Application Form - Step 2' as const,
  3: 'New Application Form - Step 3' as const,
  4: 'New Application Form - Step 4' as const,
  5: 'New Application Form - Step 5' as const
}

export type ApartmentStep =
  | typeof ApartmentStepPageNames[0]
  | typeof ApartmentStepPageNames[1]
  | typeof ApartmentStepPageNames[2]
  | typeof ApartmentStepPageNames[3]
  | typeof ApartmentStepPageNames[4]
  | typeof ApartmentStepPageNames[5]
  | typeof ApartmentStepPageNames[6]
  | typeof ApartmentStepPageNames[7]
  | typeof ApartmentStepPageNames[8]
  | typeof ApartmentStepPageNames[9]
  | typeof ApartmentStepPageNames[10]

export interface StepsInterface {
  stepProps: StepsProps
}
